import {DomainStore} from 'shared/store';
import {endpoints, types} from 'shared/core';

class BenefitsPageState {
  store = new DomainStore();
  scope;

  async load() {
    await this.store._compose([
      endpoints.BENEFITS.NAVIGATION
    ]);

    this.scope = this.store._getSingle(types.NAVIGATION_SCOPE).tabs;
  }
}

export default BenefitsPageState;
